import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { Title, Meta } from '@angular/platform-browser';

const AllImports = [
  HeaderComponent,
  FooterComponent,
]

@Component({
  standalone: true,
  imports: [
    AllImports,
    RouterModule,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  
  constructor(  
    private titleService: Title,  
    private metaTagService: Meta  
  ) { }  
    
  ngOnInit() {  
    this.titleService.setTitle("Chant's IT Solutions");  
    
    this.metaTagService.addTags([  
      { name: 'format-detection', content: 'telephone=902-578-4458' },  
      { name: 'keywords', content: 'Sydney, Glace Bay, New Waterford, North Sydney, Louisbourg, Computer Support, IT Support, technical services, website design, website development, computer repair, computer programming' },
      { name: 'description', content: 'We provide IT Support and Computer Repair for Sydney, Glace Bay, New Waterford, Sydney Mines, North Sydney, Louisbourg, and the surrounding areas in Cape Breton, Nova Scotia.' },
      { name: 'author', content: "Chant's IT Solutions"  },
      { name: 'google-site-verification', content: 'MrOsgtOmCawGyZtY8WQ3kQ6Wtvt9fXy6g_5ihWaghMU'}
    ]); 
  }
}
